import {
  VISIBLE_CITY_HUB_TABS,
  cityHubTabPath,
  getCityHubTabByKey,
  getCityHubTabByPath,
} from "../CityHub/cityHubTabs"

export const PUBLIC_CITY_DEFAULT_TAB = "calls-for-artists"
export const REQUEST_INVITE_PATH = "/request-invite"
export const PUBLIC_SITE_HOME = "https://amok.earth/"

export const PUBLIC_MARKETING_LINKS = [
  { label: "Mission & About", href: "https://amok.earth/about/" },
  { label: "Projects", href: "https://amok.earth/projects/" },
  { label: "Blog", href: "https://amok.earth/blog/" },
  { label: "Careers", href: "https://amok.earth/careers/" },
]

export const PUBLIC_FOOTER_LINK_COLUMNS = [
  [
    { label: "About", href: "https://amok.earth/about/" },
    { label: "Projects", href: "https://amok.earth/projects/" },
    { label: "Login", href: "/login", isApp: true },
    { label: "Request Invite", href: REQUEST_INVITE_PATH, isApp: true },
  ],
  [
    { label: "Cities", href: "/public/cities", isApp: true },
    { label: "Blog", href: "https://amok.earth/blog/" },
    {
      label: "Terms and Conditions",
      href: "https://amok.earth/terms-conditions/",
    },
    {
      label: "Privacy Policy",
      href: "https://amok.earth/privacy-policy/",
    },
  ],
]

export const PUBLIC_SOCIAL_LINKS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/amok.earth",
    icon: "facebook",
  },
  {
    label: "Bluesky",
    href: "https://bsky.app/profile/amokearth.bsky.social",
    icon: "bluesky",
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@amokearth",
    icon: "youtube",
  },
]

/** Prefer slug in public URLs; fall back to id for incomplete payloads. */
export const getPublicCityUrlKey = cityOrKey => {
  if (cityOrKey == null || cityOrKey === "") return null
  if (typeof cityOrKey === "string" || typeof cityOrKey === "number") {
    return String(cityOrKey)
  }
  return cityOrKey.slug || cityOrKey.id || null
}

export const publicCityTabPath = (tab, cityOrKey) => {
  const path = typeof tab === "string" ? tab : tab?.path
  if (!path) return "/public/cities"
  const key = getPublicCityUrlKey(cityOrKey)
  if (!key) return `/public/cities/${path}`
  return `/public/cities/${key}/${path}`
}

export const cityMatchesPublicParam = (city, param) => {
  if (!city || param == null || param === "") return false
  const key = String(param)
  if (city.slug && String(city.slug) === key) return true
  if (city.id != null && String(city.id) === key) return true
  return false
}

export const PUBLIC_CITY_TABS = VISIBLE_CITY_HUB_TABS.filter(
  tab => tab.path !== "creators",
)

export const getPublicCityTabByPath = pathSegment =>
  PUBLIC_CITY_TABS.find(tab => tab.path === pathSegment) || null

export const PUBLIC_CITY_TAB_ITEMS = PUBLIC_CITY_TABS.map(tab => ({
  key: tab.path,
  label: tab.label,
  icon: tab.icon,
}))

/** Resolve `/city-hub/:cityId/:tab` from a public-city engage CTA. */
export const getCityHubPathFromPublicEngage = ({ cityId, tab } = {}) => {
  if (!cityId) return null
  const hubTab = getCityHubTabByKey(tab) || getCityHubTabByPath(tab) || null
  return cityHubTabPath(hubTab?.path || PUBLIC_CITY_DEFAULT_TAB, cityId)
}

/**
 * Public city CTAs: guests → request invite; logged-in portal users → City Hub tab.
 * Passes `city` in location state so the portal banner can show name/image immediately.
 */
export const goToRequestInvite = (
  navigate,
  state = {},
  { isAuthenticated = false } = {},
) => {
  if (typeof navigate !== "function") return

  if (isAuthenticated && state?.from === "public-city" && state?.cityId) {
    const hubPath = getCityHubPathFromPublicEngage({
      cityId: state.cityId,
      tab: state.tab,
    })
    if (hubPath) {
      navigate(hubPath, {
        state: state.city
          ? { city: state.city, from: "public-city" }
          : { from: "public-city", cityId: state.cityId },
      })
      return
    }
  }

  navigate(REQUEST_INVITE_PATH, { state })
}
